import { render, staticRenderFns } from "./TestTutorials.vue?vue&type=template&id=a48cbf12&scoped=true&"
import script from "./TestTutorials.vue?vue&type=script&lang=js&"
export * from "./TestTutorials.vue?vue&type=script&lang=js&"
import style0 from "./TestTutorials.vue?vue&type=style&index=0&id=a48cbf12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48cbf12",
  null
  
)

export default component.exports